import { PrinterPosAlertOutlineIcon } from './PrinterPosAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id EACC7108-609E-4681-BAE9-BEB8EBBFF77F
 * name printer-pos-alert-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-alert-outline.svg
 * tags
 * - Printer 
 * - Alert / Error 
 */
export const PrinterPointOfSaleAlertOutlineIcon = PrinterPosAlertOutlineIcon;
export default PrinterPointOfSaleAlertOutlineIcon